// header.jsx
import { motion } from "framer-motion";

export const Header = () => {
  return (
    <section className="relative min-h-screen flex items-center">
      {/* Background Image */}
      {/* En xl+ la foto se ensancha anclada a la izquierda: el kiosco principal (≈41-62% del
          ancho de la foto) queda a la derecha del texto en vez de detrás de él. */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img
          src="/images/hero-kiosks.webp"
          srcSet="/images/hero-kiosks-1080.webp 1080w, /images/hero-kiosks.webp 1920w"
          sizes="100vw"
          alt="Kinitas parking kiosks installed on site"
          fetchpriority="high"
          className="absolute inset-y-0 left-0 w-full h-full object-cover object-[55%_center] lg:object-center xl:w-[115%] xl:max-w-none xl:object-[center_65%]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a23]/80 via-[#0a0a23]/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-8 py-16 lg:py-32 w-full">
        <div className="max-w-xl">
          <motion.h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
          >
            Turn Every Lane Into a Revenue Machine
          </motion.h1>
          <motion.p
            className="text-base sm:text-lg text-white/80 mb-10 leading-relaxed"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.7,
              delay: 0.15,
              ease: [0.25, 0.1, 0.25, 1],
            }}
          >
            Kinitas builds self-service kiosks for car washes, parking lots,
            and retail — so your operation runs 24/7 without adding headcount.
          </motion.p>
          <motion.a
            href="#solutions"
            className="inline-flex items-center justify-center bg-white text-[#1a1f6c] font-medium rounded-lg px-8 py-4 hover:bg-gray-100 transition-colors duration-300"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.7,
              delay: 0.3,
              ease: [0.25, 0.1, 0.25, 1],
            }}
          >
            See our solutions
          </motion.a>
        </div>
      </div>
    </section>
  );
};
